// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';

import { bindActionCreatorsSafe } from 'util/safeDispatch';
import localizedStrings from 'util/localizedStrings';
import { getDismissedMessageIds, getReachoutMessages } from 'state/selectors';
import type { ReachoutMessage } from 'state/types';
import Reachout from 'portfolio-shared/view/Reachout/Reachout';
import { logout } from 'state/commands/authCommands';
import type { Dispatch } from 'state/types';
import { actions } from 'portfolio-shared/state/reducers/dialogPanelReducer';
import '../admin-styles.css';
import { ABOUT_PANEL_ID } from 'util/constants';
import { openHelpLink, openLink } from 'util/browserUtils';
import { addDismissedReachoutMessageId } from 'state/commands/persistCommands';

const { showDialogPanel, hideDialogPanel } = actions;

type Props = {
  addDismissedReachoutMessageId: typeof addDismissedReachoutMessageId,
  dismissedMessageIds: Array<string>,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
  logout: typeof logout,
  reachoutMessages: ReachoutMessage[],
  showDialogPanel: typeof showDialogPanel,
};

class Header extends Component<Props> {
  handleLogout: Function;
  handleShowAbout: Function;
  openHelpLink: Function;

  constructor() {
    super();

    this.handleLogout = this.handleLogout.bind(this);
    this.handleShowAbout = this.handleShowAbout.bind(this);
    this.openHelpLink = this.openHelpLink.bind(this);
  }

  handleLogout() {
    this.props.logout();
  }

  handleShowAbout() {
    this.props.showDialogPanel(ABOUT_PANEL_ID);
  }

  openHelpLink() {
    openHelpLink(this.props.intl);
  }

  render() {
    const {
      addDismissedReachoutMessageId,
      dismissedMessageIds,
      reachoutMessages,
    } = this.props;

    return (
      <header>
        <Reachout
          reachoutMessages={reachoutMessages}
          className="reachout"
          classNameDismiss="reachoutDismiss"
          onDismissMessage={addDismissedReachoutMessageId}
          dismissedMessageIds={dismissedMessageIds}
          openLink={openLink}
        />
        <div className="app-header">
          <a
            className="header-item"
            data-test-name="logout-link"
            onClick={this.handleLogout}
          >
            <FormattedMessage {...localizedStrings.NAV_LOGOUT} />
          </a>
          <a
            className="header-item"
            data-test-name="help-link"
            onClick={this.openHelpLink}
          >
            <FormattedMessage {...localizedStrings.NAV_HELP} />
          </a>
          <a
            className="header-item"
            data-test-name="about-link"
            onClick={this.handleShowAbout}
          >
            <FormattedMessage {...localizedStrings.NAV_ABOUT} />
          </a>
          <div className="horizontal-spacer-infinite" />
          <div className="logo" />
        </div>
      </header>
    );
  }
}

export default connect(
  state => ({
    reachoutMessages: getReachoutMessages(state),
    dismissedMessageIds: getDismissedMessageIds(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      addDismissedReachoutMessageId,
      logout,
      hideDialogPanel,
      showDialogPanel,
    })
)(injectIntl(Header));



// WEBPACK FOOTER //
// ./src/view/App/Header.js